import { UserR, UserRoleInput } from '../services/users';

// Utility functions for user form handling
export const createConditionKey = (condition: Record<string, unknown> | null): string => {
  if (!condition || typeof condition !== 'object' || Object.keys(condition).length === 0) {
    return 'no_condition';
  }

  return JSON.stringify(condition);
};

export const createConditionOptionValue = (id: number, condition: Record<string, unknown> | null): string => {
  return `${id}-${createConditionKey(condition)}`;
};

export const transformRoleValueToRoleData = (roleValue: string): UserRoleInput => {
  const [roleId, conditionKey] = roleValue.split('-');
  return {
    roleId: parseInt(roleId),
    condition: conditionKey !== 'no_condition' ? JSON.parse(conditionKey) : null
  };
};

export const createInitialRolesValue = (user: UserR): string[] => {
  return user.roles.map((el) => {
    const roleId = el.role.id;
    const conditionKey = createConditionKey(el.condition);
    return `${roleId}-${conditionKey}`;
  });
};
